import styled from "styled-components"

export const Container = styled.div`
    background-color: var(--medGrey);
    display: flex;
`

export const Wrapper = styled.div`
    flex: 1;
`

export const Main = styled.div`
    margin-top: 10px;
    flex: 4;
    color: var(--lightGrey);
    padding: 20px;
`

export const UserWrapper = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
`

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const Title = styled.h1`
`

export const StyledButton = styled.button`
    width: 80px;
    border: none;
    padding: 5px;
    background-color: var(--primary);
    border-radius: 5px;
    color: var(--white);
    font-size: var(--fontM);
    cursor: pointer;
`

export const Display = styled.div`
    display: flex;
    justify-content: space-between;
`

export const WideBox = styled.div`
    margin-bottom: 20px;
    padding: 20px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
    border-radius: 10px;
`

export const DisplayTop = styled.div`
    display: flex;
    align-items: center;
`

export const DisplayInfo = styled.div`
    display: flex;
    justify-content: space-between;
`

export const DisplayBottom = styled.div`
    margin-top: 20px;
`

export const DisplayLeft = styled.div`
    padding: 20px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    margin-right: 20px;
    background-color: var(--darkGrey);
    border-radius: 10px;
    margin-bottom: 20px;
    max-width: 600px;
    flex: 1;
`

export const DisplayRight = styled.div`
    padding: 20px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    margin-left: 20px;
    background-color: var(--darkGrey);
    border-radius: 10px;
    margin-bottom: 20px;
    flex: 2;
`

export const UserImage = styled.img`
    height: 40px;
    width: 40px;
    border-radius: 50%;
    object-fit: cover;
`

export const UserTitle = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 20px;
`

export const UserName = styled.span`
    font-weight: 600;
`

export const UserJob = styled.span`
    font-weight: 300;
`

export const UserDetailsTitle = styled.span`
    font-size: var(--fontS);
    font-weight: 600;
`

export const UserDetails = styled.div`
    display: flex;
    align-items: center;
    margin: 20px 0px;
`

export const UserDetailsIcon = styled.span`
    font-size: var(--fontS) !important;
    color: var(--secondary);
`

export const UsersDetailsInfo = styled.span`
    margin-left: 10px;
`

export const BoxTitle = styled.h3`
    margin-bottom: 10px;
`

export const StyledForm = styled.form`
    display: flex;
    flex-wrap: wrap;
`

export const FormItem = styled.div`
    width: 400px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 15px;
    margin-right: 20px;
`

export const StyledSelect = styled.select`
    width: 400px;
    color-scheme: dark;
    height: 30px;
    border-radius: 5px;
`

export const StyledOption = styled.option`
`

export const StyledLabel = styled.label`
    margin-bottom: 5px;
`

export const StyledInput = styled.input`
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    border: none;
    border-bottom: 1px solid var(--primary);
    height: 30px;

    :focus{
        border-bottom: 1px solid var(--secondary);
        outline: none;
    }
`

export const Upload = styled.div`
    display: flex;
    align-items: center;
`

export const UpdateImage = styled.img`
    width: 100px;
    height: 100px;
    border-radius: 10px;
    object-fit: cover;
    margin-right: 20px;
`

export const UploadIcon = styled.div`
    cursor: pointer;
    color: var(--secondary);
`

export const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`

export const ButtonWrapper = styled.div`
    margin-bottom: 20px;
    padding: 20px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    width: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`

export const Message = styled.div`
    margin-top: 20px;
    color: var(--secondary);
`

export const StyledTextArea = styled.textarea`
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    border: 1px solid var(--primary);
    width: 350px;
    height: 250px;

    :focus{
        border: 1px solid var(--secondary);
        outline: none;
    }
`

export const CreateImage = styled.img`
    width: 80px;
    height: 80px;
    border-radius: 10px;
    object-fit: cover;
    margin-right: 20px;
    background-color: var(--medGrey);
`

